import { Endpoints } from 'types/endpoints';

import { withVariables } from 'utils/string';
import { request } from 'services/Api';


export interface CreateParams {
    search: string;
}
export const create = async (params?: CreateParams): Promise<any> => {
    await request({
        method: 'POST',
        path: withVariables(Endpoints.WorkerJobSearchesQueries, params),
        requestParams: params,
    });
};